import { render, staticRenderFns } from "./HomeRecruit.vue?vue&type=template&id=6489f4ea&scoped=true"
import script from "./HomeRecruit.vue?vue&type=script&lang=js"
export * from "./HomeRecruit.vue?vue&type=script&lang=js"
import style0 from "./HomeRecruit.vue?vue&type=style&index=0&id=6489f4ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6489f4ea",
  null
  
)

export default component.exports